import React, { useState } from "react";
import moment from "moment";
import { Popover } from "flowbite-react";
import ConfirmModal from "../../../../Utils/ConfirmModal/ConfirmModal";
import Backend from "../../../../Backend/Backend";
import toast from "react-hot-toast";
import { Dialog } from "primereact/dialog";

import UpdateRate from "../UpdateRate/UpdateRate";
import EditQty from "../EditQty/EditQty";


const backend = await new Backend().init();

export default function SymbolCard(props) {
  const item = props.item;

  // MODAL STATES
  const [rate, setRate] = useState(false);
  const [edit, setEdit] = useState(false);
  const [newModal, setNewModal] = useState(false);

  // Confirm modals
  const [hidden, setHidden] = useState(false);
  const [hidden1, setHidden1] = useState(false);
  const [hidden2, setHidden2] = useState(false);

  const symboltype =
    props.type === 1
      ? "nse"
      : props.type === 2
        ? "nse_cash"
        : props.type === 3
          ? "mcx"
          : props.type === 4
            ? "fo"
            : props.type === 5
              ? "comex"
              : props.type === 6
                ? "crypto"
                : props.type === 7
                  ? "forex"
                  : props.type === 8
                    ? "us_stock"
                    : props.type === 9
                      ? "sgx"
                      : props.type === 10
                        ? "index"
                        : null;

  // -------------------------------
  // ACTION FUNCTIONS
  // -------------------------------
  const OnlySqOff = () => {
    setHidden1(false);
    backend
      .update_symbol({
        server: localStorage.getItem("server"),
        id: localStorage.getItem("id"),
        username: localStorage.getItem("username"),
        token: localStorage.getItem("token"),
        symboltype,
        symbol_id: item.id,
        status: item.only_sq == 1 ? 0 : 1,
      })
      .then((r) => {
        r.error == "False" ? toast.success(r.message) : toast.error(r.message);
        props.reload();
      });
  };

  const UpdateActive = () => {
    setHidden2(false);
    backend
      .update_symbol({
        server: localStorage.getItem("server"),
        id: localStorage.getItem("id"),
        username: localStorage.getItem("username"),
        token: localStorage.getItem("token"),
        symboltype,
        symbol_id: item.id,
        active: 1,
        status: item.status == 1 ? 0 : 1,
      })
      .then((r) => {
        r.error == "False" ? toast.success(r.message) : toast.error(r.message);
        props.reload();
      });
  };

  const ExpirySymbol = () => {
    setHidden(false);
    backend
      .expiry_symbol({
        server: localStorage.getItem("server"),
        id: localStorage.getItem("id"),
        username: localStorage.getItem("username"),
        token: localStorage.getItem("token"),
        symboltype,
        symbol_id: item.symbol_id,
      })
      .then((r) => {
        r.error == "False" ? toast.success(r.message) : toast.error(r.message);
        props.reload();
      });
  };

  return (
    <li key={item.id} className={`menuContainer text addHight`}>
      <div className="menuExchange">
        {item.type === "nse"
          ? "NSE"
          : item.type === "mcx"
            ? "MCX"
            : item.type === "fo"
              ? "OPTIONS"
              : item.type === "nse_cash"
                ? "NSE-EQUITY"
                : item.type === "comex_future"
                  ? "COMEX"
                  : item.type === "crypto_future"
                    ? "CRYPTO"
                    : item.type === "forex_future"
                      ? "FOREX"
                      : item.type === "us_stock"
                        ? "US-STOCK"
                        : item.type === "sgx"
                          ? "SGX"
                          : item.type === "index"
                            ? "OTHERS"
                            : "-"}
      </div>

      <div className="menuSymbol">{item.symbol_display}</div>
      <div className="menuExpiry">
        {item.type === "nse_cash"
          ? "EQUITY"
          : moment(item.expiry_date).format("DD-MMM")}
      </div>

      <div className="menuSymbol">{item.min_qty}</div>
      <div className="menuSymbol">{item.qty_per_order}</div>
      <div className="menuSymbol">{item.total_quantity}</div>
      <div className="menuSymbol">{item.lot_size}</div>
      <div className="menuSymbol">{item.margin}</div>

      <div className="menuSymbol">{item.Bid}</div>
      <div className="menuSymbol">{item.Ask}</div>
      <div className="menuSymbol">{item.LTP}</div>

      {/* BUTTONS */}
      <div className="menuSymbol addMore">
        {/* EXPIRY */}
        {/* EXPIRY */}
        <Popover
          open={hidden}
          arrow={false}
          onOpenChange={() => setHidden(!hidden)}
          content={
            <ConfirmModal
              text={"ARE YOU SURE YOU WANT EXPIRY SYMBOL"}
              no={() => setHidden(false)}
              yes={ExpirySymbol}
            />
          }
        >
          <button className="sym-btn btn-exp mr-2" onClick={() => setHidden(true)}>
            EXPIRY
          </button>
        </Popover>

        {/* ONLY SQ */}
        <Popover
          open={hidden1}
          arrow={false}
          onOpenChange={() => setHidden1(!hidden1)}
          content={
            <ConfirmModal
              text={"ARE YOU SURE YOU WANT DEACTIVE ONLY SQ ALL SYMBOL"}
              no={() => setHidden1(false)}
              yes={OnlySqOff}
            />
          }
        >
          <button
            className={`sym-btn mr-2 ${item.only_sq == 1 ? "btn-sq-on" : "btn-sq-off"}`}
            onClick={() => setHidden1(true)}
          >
            ONLY SQ
          </button>
        </Popover>

        {/* ACTIVE / DEACTIVE */}
        <Popover
          open={hidden2}
          arrow={false}
          onOpenChange={() => setHidden2(!hidden2)}
          content={
            <ConfirmModal
              text={"ARE YOU SURE YOU WANT UPDATE STATUS"}
              no={() => setHidden2(false)}
              yes={UpdateActive}
            />
          }
        >
          <button
            className={`sym-btn mr-2 ${item.status == 1 ? "btn-act" : "btn-dea"}`}
            onClick={() => setHidden2(true)}
          >
            {item.status == 1 ? "ACTIVE" : "DEACTIVE"}
          </button>
        </Popover>

        {/* RATE */}
        <button className="sym-btn mr-2 btn-pri" onClick={() => setRate(true)}>RATE</button>

        {/* EDIT */}
        <button className="sym-btn mr-2 btn-pri" onClick={() => setEdit(true)}>EDIT</button>
      </div>

      {/* RATE MODAL */}
      <Dialog
        visible={rate}
        onHide={() => setRate(false)}
        closeOnEscape
        closeIcon
        id="modal"
        className="modal"
      >
        <UpdateRate
          item={item}
          close={() => setRate(false)}
          reload={props.reload}
        />
      </Dialog>

      {/* EDIT QTY MODAL */}
      <Dialog
        visible={edit}
        onHide={() => setEdit(false)}
        closeOnEscape
        closeIcon
        id="modal"
        className="modal"
      >
        <EditQty
          item={item}
          close={() => setEdit(false)}
          reload={props.reload}
        />
      </Dialog>
    </li>
  );
}
